import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const productiv = defineConnector({
  identifier: "productiv",
  name: "Productiv",
  tagLine: "SaaS management and spend",
  keywords: "productiv saas management spend licenses shadow it app portfolio",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://public-api\\.productiv\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create API credentials in Productiv",
      items: [
        {
          kind: "markdown",
          content: `1. In Productiv, go to **Organization settings**
2. Click **New credential** and choose the scopes it should allow
3. Copy the client ID and client secret — the secret is shown only once`,
        },
      ],
    },
    {
      title: "Enter your Productiv credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
        {
          kind: "input",
          label: "Scopes (optional)",
          placeholder: "https://api.productiv.com/apps.read",
          target: { kind: "oauthConnection", field: "scopes" },
          helperText:
            "Space separated. Leave blank to get every scope the credential was created with.",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://login.api.productiv.com/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://public-api.productiv.com/pull/v3/apps",
  },
});
